/** Buckets in first-seen order: a group lands where its first member fell. */
export const groupBy = <T>(
  items: readonly T[],
  key: (item: T) => string,
): [T, ...T[]][] => {
  const buckets = new Map<string, [T, ...T[]]>();
  for (const item of items) {
    const k = key(item);
    const bucket = buckets.get(k);
    if (bucket) bucket.push(item);
    else buckets.set(k, [item]);
  }
  return [...buckets.values()];
};
